export default __webpack_public_path__ + "static/media/0xe2a59d5e33c6540e18aaa46bf98917ac3158db0d.269833d5.svg";